import { render } from "./B2bPageIssues.vue?vue&type=template&id=5d2d6af0&scoped=true&lang=pug"
import script from "./B2bPageIssues.vue?vue&type=script&lang=js"
export * from "./B2bPageIssues.vue?vue&type=script&lang=js"

import "./B2bPageIssues.vue?vue&type=style&index=0&id=5d2d6af0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d2d6af0"]])

export default __exports__